import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { Errors } from 'src/infrastructure/labels/errors';
import { Successes } from 'src/infrastructure/labels/successes';
import { Validator } from 'src/infrastructure/validation/validator';
import { CompleteChangePasswordRequestModel } from 'src/models/requestModels/password/completeChangePasswordRequestModel copy';
import { ToastService } from 'src/services/core/toast/toast.service';
import { ForgottenpasswordService } from 'src/services/request/forgottenpassword/forgottenpassword.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent extends BaseComponent implements OnInit {


  changePasswordsInfo: FormGroup;

  private key: string | null = '';

  isCapitalLettersCheckValid = false;
  isSmallLettersCheckValid = false;
  isDigitsCheckValid = false;
  isLengthCheckValid = false;
  isSymbolCheckValid = false;

  constructor(
    private FB: FormBuilder,
    private forgottenPasswordService: ForgottenpasswordService,
    private activatedRoute: ActivatedRoute,
    private toast: ToastService,
    private router: Router
  ) {
    super();
    this.pageTitle = "changepassword";
    this.changePasswordsInfo = FB.group({
      newPassword: ['', [Validators.required, Validators.minLength(8), Validator.ReactiveFormsValidators.passwordValidator]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8), Validator.ReactiveFormsValidators.passwordValidator]]
    })
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.key = params['hash'];
    })
  }

  change() {
    this._error = Validator.FormGroupValidator.validate(this.changePasswordsInfo);
    if (this._error) {
      this.toast.error(this.pageDetails()[this._error] + Errors.bg.invalidField);
      this._error = '';
      return;
    }
    if (!Validator.InputValidator.password.confirmPasswords(
      this.changePasswordsInfo.get('newPassword')?.value,
      this.changePasswordsInfo.get('confirmPassword')?.value
    )) {
      this.toast.error(Errors.bg.passwordMatch);
      this._error = '';
      return;
    }
    let completeChangePasswordRequestModel : CompleteChangePasswordRequestModel = {} as any;
    completeChangePasswordRequestModel.password = this.changePasswordsInfo.get('newPassword')?.value,
    completeChangePasswordRequestModel.password_confirmation = this.changePasswordsInfo.get('confirmPassword')?.value,
    this.forgottenPasswordService.resetPassword(completeChangePasswordRequestModel, this.key).subscribe(() => {
        this.changePasswordsInfo.reset();
        this.toast.success(Successes.bg.changedPassword)
    })
  }

  checkPassoword(passwordEventTarget: EventTarget | null) {
    if (!passwordEventTarget) return;
    const password = (passwordEventTarget as HTMLInputElement).value;
    this.checkForCapitalLetters(password);
    this.checkForLength(password);
    this.checkForSmallLetters(password);
    this.checkForDigit(password);
    this.checkForSymbol(password);
  }

  checkForCapitalLetters(password: string) {
    this.isCapitalLettersCheckValid = password.search(/[A-ZА-Я]/) >= 0

  }

  checkForLength(password: string) {
    this.isLengthCheckValid = password.length >= 8;
  }

  checkForSmallLetters(password: string) {
    this.isSmallLettersCheckValid = password.search(/[a-zа-я]/) >= 0
  }

  checkForDigit(password: string) {
    this.isDigitsCheckValid = password.search(/\d/) >= 0
  }

  checkForSymbol(password: string) {
    this.isSymbolCheckValid = password.search(/\W/) >= 0
  }

  forgottenPassword() {
    this.router.navigate(['password/forgotten']);
  }


}
